import React from 'react';
import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Marks a partner's non-billable test restaurant wherever restaurants are
 * listed. Renders nothing for any other restaurant, so callers can drop it in
 * unconditionally.
 */
export default function TestRestaurantTag({ company, className = undefined }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:ProviderBilling:TestRestaurant' });

  if (!company?.is_test_restaurant) {
    return null;
  }

  return (
    <Tooltip title={t('tag_tooltip')}>
      <Tag color="warning" className={className} data-testid="test-restaurant-tag">
        {t('tag')}
      </Tag>
    </Tooltip>
  );
}
